'use client';
import { useEffect } from 'react';
import { gtmSitewide } from '@/utils/events/gtmEvents';

export default function GtmSitewide({ pageTitle, templateType }) {
  useEffect(() => {
    async function runGtmSitewideEvent() {
      if (window !== undefined) {
        window.dataLayer = window.dataLayer || [];
        gtmSitewide(pageTitle, templateType);
      }
    }
    runGtmSitewideEvent();
  }, [pageTitle, templateType]);
  return null;
}
